import cn from "classnames";
import { Text } from "@rshbintech.dboul/core-ui";
import {
  Warning as WarningIcon,
  Bell as BellIcon,
} from "@rshbintech.dboul/icons";
import { NotificationItemProps } from "./types";
import styles from "./styles.scss";

export const NotificationItem = ({
  notificationData,
  onClick,
}: NotificationItemProps) => {
  const { date, subject, isImportant, body } = notificationData;

  return (
    <div
      className={styles.container}
      onClick={onClick}
      data-rptracker-event="click"
      data-rptracker-category="notifications"
      data-rptracker-action="notificationsOneNotificationClick"
    >
      <div className={styles.title}>
        {isImportant ? (
          <WarningIcon className={styles.icon} size="medium" type="danger" />
        ) : (
          <BellIcon
            className={cn(styles.icon, styles["icon-bell"])}
            size="medium"
          />
        )}
        <Text weight="medium" className={styles.subject}>
          {subject}
        </Text>
      </div>
      <div className={styles.info}>
        <Text className={styles.body}>{body}</Text>
        <Text className={styles.date}>{date}</Text>
      </div>
    </div>
  );
};
